module.exports = __webpack_public_path__ + "assets/flags/cy.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cy.svg
// module id = 496
// module chunks = 0